const EMPTY_ARRAY = Object.freeze([])
const EMPTY_OBJECT = Object.freeze({})
const EMPTY_SET = Object.freeze(new Set())
const EMPTY_MAP = Object.freeze(new Map())
const ZERO_WIDTH_SPACE = '\u200B'.toString()
const AI_TEXT_DISCLAIMER =
  'AI content may not always be accurate or reflect legal requirements. Verify independently before proceeding'
export { AI_TEXT_DISCLAIMER, EMPTY_ARRAY, EMPTY_MAP, EMPTY_OBJECT, EMPTY_SET, ZERO_WIDTH_SPACE }
